import request from "@/utils/request";

/**
 * 查询碳汇数据列表
 * @param params
 * @returns {*}
 */
export function getCarbonList(params) {
    return request({
        url: "/api/backend/trade/data/getList",
        method: "get",
        params
    });
}

/**
 * 查询支持的币种
 * @param params
 * @returns {*}
 */
export function getSupportCurrency(params) {
    return request({
        url: "/api/backend/trade/data/getSupportCurrency",
        method: "get",
        params
    });
}

/**
 * 修改碳汇数据
 * @param params
 * @returns {*}
 */
export function updateCarbon(params) {
    return request({
        url: "/api/backend/trade/data/update",
        method: "post",
        data: params
    });
}
